const EmptyRow = () => {
  return (
    <tr className="text-xs h-6">
      {Array.from({ length: 14 }).map((_, i) => (
        <td key={i} className="p-1 text-gray-600 bg-gray-100"></td>
      ))}
    </tr>
  );
};

export default EmptyRow;
